"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_MAX_STACKED_TOASTS = exports.DEFAULT_TOAST_DURATION_MS = void 0;
var DEFAULT_TOAST_DURATION_MS = 7000;
exports.DEFAULT_TOAST_DURATION_MS = DEFAULT_TOAST_DURATION_MS;
var DEFAULT_MAX_STACKED_TOASTS = 3;
exports.DEFAULT_MAX_STACKED_TOASTS = DEFAULT_MAX_STACKED_TOASTS;